import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54d07582"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-card shadow rounded-4 d-flex flex-column overflow-hidden" }
const _hoisted_2 = { class: "image-wrapper" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-content p-4 text-start d-flex flex-column flex-grow-1" }
const _hoisted_5 = ["href"]



const defaultImage = "https://dummyimage.com/300.png/09f/fff";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    product: {},
    fontPrincipal: {},
    fontText: {},
    getAssetUrl: { type: Function },
    whatsappNumber: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.getAssetUrl(_ctx.product.image || defaultImage),
        alt: _ctx.product.title,
        class: "product-image"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        class: "buy-now-button fw-bold mt-auto text-center text-white text-decoration-none",
        href: `https://wa.me/${_ctx.whatsappNumber}?text=Hola,%20me%20interesa%20el%20producto:%20${encodeURIComponent(_ctx.product.title)}`,
        target: "_blank",
        rel: "noopener"
      }, " Cotizar por WhatsApp ", 8, _hoisted_5)
    ])
  ]))
}
}

})